import { useEffect, useState, useCallback, useContext } from "react";
import { BreadCrumbs, CacheDataLoader } from "components";
import 'react-vertical-timeline-component/style.min.css';
import commonStyles from "styles/common";
import viewsStyles from "styles/views";
import "styles/verticaltimeline.custom.css";
import { Grid2 as Grid, Container, CircularProgress } from "@mui/material";
import EventsEmitter from "events/EventsEmitter";
import { tss } from "tss-react";
import { ProjectsList } from "./ProjectsList";
import { ViewsList } from "./ViewsList";
import { IssuesList } from "./IssuesList";
import { PendingList } from "./PendingList";
import { ReportList } from "./ReportList";
import { Scrollbars } from "react-custom-scrollbars";
import {AppContext} from "views/Loader";
import { useSelector } from 'react-redux';

const range = (start: number, end: number) => Array.from({length: (end - start)}, (v, k) => k + start);
const useStyles = tss.create(() => ({
    CircularProgress: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto auto',
        width: 'unset',
        minWidth: '30px',
        minHeight: '30px',
    }
}));

export default function Home() {
    const [data, setData] = useState<any>(null);
    const { classes: common, cx } = commonStyles();
    const { classes: viewsClasses } = viewsStyles();
    const [progress, setProgress] = useState(0);
    const { classes } = useStyles();
    const [loaded, setLoaded] = useState<any>(false);
    const [loadingEnvironment, setLoadingEnvironment] = useState<any>(false);

    const [nbProjects, setNbProjects] = useState(0)
    const [nbViews, setNbViews] = useState(0)
    const [nbPending, setNbPending] = useState(0)
    const [nbIssue, setNbIssue] = useState(0)
    const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;
    const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;

    const onDataLoad = useCallback((cacheData: any) => {
            if(loaded) return;

            setData(cacheData);
            
            setLoaded(true);
    }, [data, setData, loaded, setLoaded]);
    
    const { 
        tourActive,
        setRunTour,
        setStepIndex
    } = useContext<any>(AppContext);

    useEffect(() => {
        setTimeout(() => {
            if(!tourActive) return;
            
            setStepIndex(0);
            setRunTour(true);
        }, 2000);
    }, [tourActive]);

    useEffect(() => {
        if(data !== null) {
            const projectsList = data["projects"];
            const keys = Object.keys(projectsList).filter((id: string) => !demoProjectsHidden || !defaultProjects.includes(id)) ;
            setNbProjects(keys.length)
            var currentList: any = [];
            var currentIssuesList : any = [];
            const views = data["views"];
            let viewsArray: any = Object.values(views).filter((item: any) => !demoProjectsHidden || !defaultProjects.includes(item.project)) ;
            setNbViews(viewsArray.length)

            const entities = data["entities"];
            let comptIssue = 0;
            let comptPending = 0;
        
          

            Object.entries(entities).map((entry: any, index: number) => {
                var id = entry[0];
               
                var pending: any = Object.values(entry[1]).filter((p: any) => {
                    return p.state === "PARTIAL" && p.type === "FILE" && p.name;
                });

                var issue: any = Object.values(entry[1]).filter((p: any) => {
                    return p.state === "ERROR" && p.name;
                });

               
                if (projectsList[id] && pending.length > 0 && (/*!demoProjectsHidden || */!defaultProjects.includes(id))) {
                    currentList.push(projectsList[id]);
                    comptPending += pending.length;
                }

                if (projectsList[id] && issue.length > 0 && (/*!demoProjectsHidden || */!defaultProjects.includes(id))) {
                    currentIssuesList.push(projectsList[id]);
                    comptIssue += issue.length;
                }
                setNbPending(comptPending)
                setNbIssue(comptIssue)

                return true;
            });
        }
     
    }, [data]);

    useEffect(() => {
        
        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        const handleLoadingEnvironment = (state: boolean) => {
            setLoadingEnvironment(state);
        };

        EventsEmitter.on("projects_progress", handleProgress);
        EventsEmitter.on("loading_environment", handleLoadingEnvironment);
        
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
            EventsEmitter.removeEventListener("loading_environment", handleLoadingEnvironment);
        };
      
    }, [data]);

    return (
        <CacheDataLoader onDataLoad={onDataLoad}>
             {/* <ObjectCount project={nbProjects} view={nbViews} pending={nbPending} issue={nbIssue}/> */}
            <div className={viewsClasses.root}>
                <Container
                    maxWidth={false}
                    sx={{
                        //maxWidth: CONTAINER_MAX_WIDTH,
                        display: 'flex',
                        minWidth: 0,
                        flex: 1,
                        flexDirection: 'column',
                        p: '0 20px'
                    }}
                    disableGutters
                >
                    <div className={cx(common.middle, viewsClasses.topHeader)}>
                        <BreadCrumbs label="Dashboard" className="mainTitle"/>
                    </div>
                    <Scrollbars
                        autoHeight
                        autoHeightMax={"calc(100vh - 200px)"}
                        style={{ overflowX: "hidden"}}
                    >
                       { loadingEnvironment ? (
                            <CircularProgress />
                        ) : (
                            <Grid container spacing={3.75} sx={{padding: '0 20px 15px'}}>
                                <Grid size={{ xs: 12, lg: 12, xl: 12 }}>
                                    <ProjectsList nb={nbProjects}/>
                                </Grid>
                                <Grid size={{ xs: 12, lg: 12, xl: 7 }}>
                                    <ViewsList nb={nbViews}/>
                                </Grid>
                                <Grid size={{ xs: 12, lg: 5 }}>
                                    <ReportList />
                                </Grid>
                                <Grid size={{ xs: 12, lg: 6 }}>
                                    <IssuesList nb={nbIssue}/>
                                </Grid>
                                <Grid size={{ xs: 12, lg: 6 }}>
                                    <PendingList nb={nbPending}/>
                                </Grid>
                            </Grid>
                        )}
                    </Scrollbars>
                </Container>
            </div>
        </CacheDataLoader>
    );
}
